import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-filter-chip-multiple',
  templateUrl: './search-filter-chip-multiple.component.html',
  styleUrl: './search-filter-chip-multiple.component.scss',
})
export class SearchFilterChipMultipleComponent {
  @Input() name!: string;
  @Input() options!: {
    label: string;
    value: string;
    selected?: boolean;
  }[];

  @Output() emitFilter = new EventEmitter<any>();

  selectedOption: { label: string; value: string }[] | null = null;
  descriptionSelectedOption: string = '';

  clearSelectedOption() {
    this.selectedOption = null;
    this.descriptionSelectedOption = '';
    this.emitFilter.emit(this.descriptionSelectedOption);
  }

  applyFilter() {
    this.selectedOption = this.options.filter((option) => option.selected);
    this.descriptionSelectedOption = this.selectedOption
      .map((option) => option.label)
      .join(',');
    const valueSelectedOptions = this.selectedOption
      .map((option) => option.value)
      .join(',');

    this.emitFilter.emit(valueSelectedOptions);
  }

  resetSelection() {
    this.options.forEach((option) => (option.selected = false));
  }
}
